import React from 'react';
import { Modal, Button, Icon } from 'antd';
import { connect } from 'react-redux';
import { hideModal } from '../actions/utils';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FEATURE_LABELS } from '../utils/subscriptionPlans';

/**
 * survey-api renew/upgrade prompt (flag-on counterpart of UnpaidBill).
 * Props:
 *  - reason: 'expired' | 'suspended' (from surveyApi 402/403 normalization)
 *  - quota: { featureKey: 'FORM'|'RESPONSE'|'STORAGE', limit, used, code }
 *    (from surveyApi 429 normalization; STORAGE limit/used are in bytes).
 *    `limit` is optional: without it (FORM_LIMIT_REACHED before usage has
 *    loaded) a limit-less forms message is shown.
 *  - redirectOnClose: same behavior as UnpaidBill
 */
const quotaDisplay = quota => {
  if (quota.featureKey === 'STORAGE') {
    return {
      limit: `${Math.round(quota.limit / (1024 * 1024)).toLocaleString()} MB`,
      feature: FEATURE_LABELS.STORAGE,
    };
  }
  return {
    limit: Number(quota.limit).toLocaleString(),
    feature: FEATURE_LABELS[quota.featureKey] || quota.featureKey,
  };
};
const RenewSubscription = props => {
  const onClose = () => {
    props.hideModal();
    props.redirectOnClose &&
      props.history.replace(`/${props.lang}/forms/${props.activeSurvey.id}`);
  };

  return (
    <Modal
      destroyOnClose
      centered
      visible={props.modalShow}
      maskStyle={{
        background: 'rgba(0, 0, 0, 0.90)'
      }}
      bodyStyle={{ padding: 0 }}
      onCancel={onClose}
      title={
        props.quota ? (
          <FormattedMessage
            id="Subscription.PlanLimitReached"
            defaultMessage="Plan limit reached"
          />
        ) : (
          <FormattedMessage
            id="Subscription.RenewTitle"
            defaultMessage="Renew your subscription"
          />
        )
      }
      footer={[
        <span
          key="back"
          style={{ color: '#0628A5', cursor: 'pointer', marginRight: '1rem' }}
          onClick={onClose}
        >
          <FormattedMessage id="Button.Dismiss" defaultMessage="Dismiss" />
        </span>,
        <Button
          key="renew"
          type="primary"
          onClick={() => {
            props.hideModal();
            props.history.push(`/${props.lang}/settings/subscriptions`);
          }}
        >
          {props.quota ? (
            <FormattedMessage
              id="Subscription.Upgrade"
              defaultMessage="Upgrade plan"
            />
          ) : (
            <FormattedMessage
              id="Subscription.RenewNow"
              defaultMessage="Renew now"
            />
          )}
        </Button>
      ]}
    >
      <div>
        <div
          style={{
            marginTop: '1rem',
            backgroundColor: '#D7373F',
            color: 'white',
            padding: '1rem 0'
          }}
        >
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 0
            }}
          >
            <Icon
              type="warning"
              theme="filled"
              style={{ marginRight: '.5rem', fontSize: '24px' }}
            />{' '}
            {props.quota ? (
              <FormattedMessage
                id="Subscription.QuotaBanner"
                defaultMessage="You have used up your monthly allowance"
              />
            ) : props.reason === 'suspended' ? (
              <FormattedMessage
                id="Subscription.SuspendedBanner"
                defaultMessage="Your account has been suspended"
              />
            ) : (
              <FormattedMessage
                id="Subscription.ExpiredBanner"
                defaultMessage="Your subscription has expired"
              />
            )}
          </p>
        </div>
        <div style={{ margin: '2rem 0', padding: '0 24px' }}>
          {props.quota && props.quota.limit == null ? (
            <p>
              <FormattedMessage
                id="Subscription.FormLimitDescription"
                defaultMessage="Your plan does not allow creating more forms. Upgrade your plan to keep going."
              />
            </p>
          ) : props.quota ? (
            <p>
              <FormattedMessage
                id="Subscription.QuotaDescription"
                defaultMessage="You have reached your limit of {limit} {feature}. Upgrade your plan to keep going."
                values={quotaDisplay(props.quota)}
              />
            </p>
          ) : (
            <p>
              <FormattedMessage
                id="Subscription.RenewDescription"
                defaultMessage="Renew your subscription to restore access to all features on Insyt."
              />
            </p>
          )}
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  return {
    lang: state.intl.lang,
    activeSurvey: state.dashboard.active_survey
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideModal: () => {
      dispatch(hideModal());
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RenewSubscription)
);
